import { useAppSelector } from 'app/hooks';
import { priceFormat } from 'helper/common';
import { useTranslation } from 'react-i18next';
import { formPassengersDataState, selectedFlightPriceState, selectedFlightState } from 'store/flight/flightSlice';
import FlightBookSidebarSegment from './Segment';
import * as S from './Sidebar.styles';
const FlightBookSidebar = () => {
  const { t } = useTranslation();
  const flight = useAppSelector(selectedFlightState);
  const flightAmount = useAppSelector(selectedFlightPriceState);
  const passengerList = useAppSelector(formPassengersDataState);
  return (
    <S.Wrapper>
      {flight?.originDestinationOption.map((e, i) => {
        return <FlightBookSidebarSegment flightSegment={e.flightSegment} key={i} index={i} />;
      })}
      <S.Footer>
        <S.Passengers>
          {Object.keys(passengerList).map((e) => {
            if (!passengerList[e]) return '';
            return (
              <S.Passenger key={e}>
                {t(`constants.passengerTypes.${e}.title`)} x {passengerList[e]}
              </S.Passenger>
            );
          })}
        </S.Passengers>
        <S.AmountTitle>
          {t('pages.services.flight.pages.book.sections.passengers.sections.sidebar.sections.amountBlock.taxAndFees')}:
        </S.AmountTitle>
        <S.AmountWrapper>
          <S.AmountBox>
            <S.Amount>{priceFormat(flightAmount?.totalMilage || 0)}</S.Amount>
            <S.AmountSuffix>{t('constants.miles')}</S.AmountSuffix>
          </S.AmountBox>
          <S.AmountBox>
            <S.Amount>
              {flightAmount
                ? priceFormat(
                    flightAmount.pricedItineraries.pricedItinerary[0].airItineraryPricingInfo.itinTotalFare[0].totalFare
                      .amount -
                      flightAmount.pricedItineraries.pricedItinerary[0].airItineraryPricingInfo.itinTotalFare[0]
                        .baseFare.amount
                  )
                : ''}
            </S.Amount>
            <S.AmountSuffix>{t('constants.currency')}</S.AmountSuffix>
          </S.AmountBox>
        </S.AmountWrapper>
      </S.Footer>
    </S.Wrapper>
  );
};

export default FlightBookSidebar;
